<template>
  <Portal>
    <div class="toolbar">
      <slot />
    </div>
  </Portal>
</template>

<script>
import Portal from "./Portal";

export default {
  name: "ToolbarComponent",
  components: { Portal },
};
</script>

<style scoped lang="css">
.toolbar {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  height: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/pdf-lib-contents/Toolbar.vue